import columns from '../../../../react-table/helpers/columns';

export const textConditionalProps = (state, rowInfo) => {
  const className =
    rowInfo &&
    rowInfo.row.paperFree &&
    rowInfo.row.paperFree === 'N' ? 'text-red' : 'text-green';
  return { className };
};

export const bgConditionalProps = (state, rowInfo) => {
  let className =
    rowInfo &&
    rowInfo.row.paperFree &&
    rowInfo.row.paperFree === 'N' ? 'bg-red' : 'bg-green';
  className += ' text-white';
  return { className };
};

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator').withGetProps(textConditionalProps),
        new TextColumn('Destination operator', 'destinationOperator').withGetProps(textConditionalProps),
        new TextColumn('Carrier', 'carrier').withGetProps(textConditionalProps),
        new TextColumn('Departure Location', 'departureLocation').withGetProps(textConditionalProps),
        new TextColumn('Arrival Location', 'arrivalLocation').withGetProps(textConditionalProps),
        new TextColumn('Origin IMPC', 'originImpc').withGetProps(textConditionalProps),
        new TextColumn('Destination IMPC', 'destinationImpc').withGetProps(textConditionalProps),
        new NonZeroNumberColumn('Volume', 'volume').withGetProps(textConditionalProps),
        new TextColumn('PaperFree', 'paperFree').withGetProps(bgConditionalProps),
      ],
    },
  ];
};
